import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Categorys from "../components/Categorys";
import Specialties from "../components/Specialties";
import FeatureProducts from "../components/products/FeatureProducts";
import Products from "../components/products/Products";
import Footer from "../components/Footer";
import { get_products } from "../store/reducers/homeReducer";
import Hero from "../components/Hero";
import Post from "../components/Post";
import LatestBlogs from "../components/LatestBlogs";
const Home = () => {
  const dispatch = useDispatch();
  const { products, latest_product, topRated_product, discount_product } =
    useSelector((state) => state.home);
  useEffect(() => {
    dispatch(get_products());
  }, []);
  return (
    <div
      className="w-full bg-cover bg-no-repeat bg-center sm:bg-left"
      style={{
        backgroundImage: `url(${process.env.REACT_APP_CLIENT_URL}/images/body2.jpg)`,
      }}
    >
      <Hero />
      <div className="my-4 mt-10 bg-[#f6fffc]">
        <Specialties />
        <LatestBlogs />
      </div>
      <div className="px-32 py-10 my-20 md:px-5">
        <Post
          title="استشارة طبية عن بُعد"
          subTitle="الوصول إلى الرعاية الصحية بكل سهولة"
          description="مع منصة طبيبي، لم يعد الحصول على استشارة طبية يتطلب التنقل أو الانتظار لساعات طويلة. الآن، يمكنك حجز استشارة طبية عن بُعد مع الأطباء المختصين بسهولة تامة، والتحدث معهم عبر الفيديو أو الدردشة النصية لتقييم حالتك الصحية واتخاذ القرارات المناسبة في الوقت المناسب"
          image={`${process.env.REACT_APP_CLIENT_URL}/images/doc/medoc.jpg`}
          position="left"
          btnText="احصل على استشارة"
          btnLink="doctors"
        />
        <Post
          title=" الأطباء والمراكز الطبية"
          subTitle="دليلك الشامل إلى أفضل الأطباء والمراكز الصحية"
          description="يتيح لك طبيبي البحث عن الأطباء والمراكز الطبية وفقًا لاختصاصاتهم ومواقعهم، مما يسهل عليك الوصول إلى الرعاية الصحية الأقرب إليك والأكثر كفاءة. بفضل التقييمات والمراجعات، يمكنك اختيار الطبيب الأنسب لحالتك بكل ثقة"
          image={`${process.env.REACT_APP_CLIENT_URL}/images/doc/docs1.jpg`}
          position="right"
          btnText="البحث عن الأطباء"
          btnLink="doctors"
        />
        <Post
          title="  حجز المواعيد بسهولة"
          subTitle="! وداعًا للانتظار الطويل، احجز موعدك الآن"
          description="  توفر منصة طبيبي نظام حجز مواعيد ذكي، يتيح لك اختيار الوقت المناسب لك بناءً على جدول الطبيب المتاح. استمتع بتجربة حجز سهلة وسريعة توفر عليك عناء الاتصال والانتظار "
          image={`${process.env.REACT_APP_CLIENT_URL}/images/doc/bookon.jpg`}
          position="left"
          btnText="احجز موعد"
          btnLink="doctors"
        />
        <Post
          title="  برامج المتابعة والرعاية المستمرة"
          subTitle="   صحتك أولويتنا، والمتابعة الطبية أصبحت أسهل  "
          description="   مع طبيبي، لن تنتهي علاقتك بالطبيب بمجرد انتهاء الاستشارة. يمكنك متابعة حالتك الصحية من خلال برامج المتابعة الطبية، وتلقي التوصيات والنصائح الدورية، مما يضمن لك العناية المستمرة بصحتك على مدار الساعة  "
          image={`${process.env.REACT_APP_CLIENT_URL}/images/doc/docs2.jpg`}
          position="right"
          btnText="سجل دخولك الان"
          btnLink="dashboard"
        />
      </div>
      <div className="my-4 mt-10 bg-[#f6fffc]">
        <Categorys />
      </div>
      <div className="py-[45px]">
        <FeatureProducts products={products} />
      </div>

      <div className="py-10">
        <div className="w-[85%] flex flex-wrap mx-auto">
          <div className="grid w-full grid-cols-3 md-lg:grid-cols-2 md:grid-cols-1 gap-7">
            <div className="overflow-hidden">
              <Products title="أحدث" products={latest_product} />
            </div>
            <div className="overflow-hidden">
              <Products title="أفضل تقييم" products={topRated_product} />
            </div>
            <div className="overflow-hidden">
              <Products title="سعر مخفض" products={discount_product} />
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Home;
